export default __webpack_public_path__ + "static/media/preview.ce6b9068.png";